// app/assets/javascripts/survey.js (or app/javascript/packs/survey.js if using Webpacker)
document.addEventListener('DOMContentLoaded', function() {
  if (localStorage.getItem('survey_shown')) return;

  // Random delay between 30 seconds (30000 ms) and 5 minutes (300000 ms)
  const randomDelay = Math.floor(Math.random() * (300000 - 30000 + 1)) + 30000;
  // const randomDelay = Math.floor(Math.random() * 20000);

  setTimeout(function() {
    // Fetch survey from backend
    $.ajax({
      url: '/end_users/surveys/new',
      method: 'GET',
      dataType: 'script',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
      success: function() {
        localStorage.setItem('survey_shown', 'true');
      },
      error: function() {
        console.error('Failed to load survey');
      }
    });
  }, randomDelay);
});
